import initialState from './../../initialState';

export default (state = initialState.auth, { type, value, response }) => {
  switch (type) {
    case 'USER_ROLES_REQUEST':
      return {
        ...state,
        fetching: 1,
        roles: [],
        apartamentos: []
      };
    case 'USER_ROLES_SUCCESS':
      return {
        ...state,
        ...value,
        fetching: 2,
        ...response
      };
    case 'USER_ROLES_FAILURE':
      return {
        ...state,
        user:{},
        fetching: 0
      };
    case 'AUTH_USER_WAIT':
      return {
        ...state,
        fetching: 1
      };
    case 'AUTH_USER':
      return {
        ...state,
        roles: value.list,
        fetching: 2
      };
    case 'SIGN_OUT_USER':
      window.localStorage.setItem('sentToServer', '0');
      return {
        ...state,
        user: {},
        roles: [],
        apartamentos: [],
        fetching: 0
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/auth/reducer.js